module.exports = __webpack_public_path__ + "static/media/icon-heart-active-blue.c43bb922.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-heart-active-blue.svg
// module id = 1464
// module chunks = 0